import PartnershipAccountsPage from './PartnershipAccountsPage';

export default PartnershipAccountsPage;
